import keyBy from 'lodash/keyBy';
import { createSelector } from 'reselect';

import type { TempAccount } from '@portal/api-models';

import type { ApplicationState } from '../types';
import { getUUIDfromProps } from '../utils';

export const getSlice = (state: ApplicationState) => state.accounts;

export const selectAccounts = (state: ApplicationState): TempAccount[] =>
  state.accounts.rows;

export const selectAccountsKeyedByUuid = createSelector(
  [selectAccounts],
  (accounts) => keyBy(accounts, 'uuid')
);

export const selectAccountsKeyedById = createSelector(
  [selectAccounts],
  (accounts) => keyBy(accounts, 'id')
);

export const selectFirstAccount = createSelector(
  [selectAccounts],
  (accounts) => accounts?.[0]
);

export const selectFirstAccountId = createSelector(
  [selectAccounts],
  (accounts) => accounts?.[0]?.id
);

export const selectFirstAccountUuid = createSelector(
  [selectAccounts],
  (accounts) => accounts?.[0]?.uuid
);

export const getHaveAccountsBeenLoaded = (state: ApplicationState) =>
  state.accounts.haveAllAccountsBeenRequested;

export const selectDeactivateAccounts = (state: ApplicationState) =>
  state.accounts.deactivationRows;

export const getAccounts = createSelector([getSlice], (accts) => accts?.rows);

export const getSelectAccountByUuid = createSelector(
  [getUUIDfromProps, selectAccounts],
  (uuid, accts) => accts.find((account) => account.uuid === uuid)
);
